<template>
  <div class="sendeveryday">
    <h1></h1>
    <a-form-model
      ref="dynamicValidateForm"
      :model="dynamicValidateForm"
      v-bind="formItemLayout"
    >
      <a-form-model-item
        v-for="(domain, index) in dynamicValidateForm.domains"
        :key="domain.key"
        v-bind="index === 0 ? formItemLayout : {}"
        :label="index === 0 ? '内容信息' : domain.key"
        :prop="'domains.' + index + '.value'"
        :rules="{
          required: true,
          message: '请输入内容(5~180个字),内容不能为空,如不需要请删除！',
          trigger: 'blur',
        }"
      >
        <!-- <a-input
          v-model="domain.value"
          placeholder="please input domain"
          style="width: 60%; margin-right: 8px"
        /> -->

        <a-textarea
          v-model="domain.value"
          placeholder="请输入内容"
          :maxLength="180"
          style="width: 500px; margin-right: 8px"
          :auto-size="{ minRows: 3, maxRows: 10 }"
        />
        <span class="suffix">{{ domain.value.length }}/180</span>
        <a-icon
          v-if="dynamicValidateForm.domains.length > 1"
          class="dynamic-delete-button"
          type="minus-circle-o"
          :disabled="dynamicValidateForm.domains.length === 1"
          @click="removeDomain(domain)"
        />
      </a-form-model-item>
      <!-- <a-form-model-item v-bind="formItemLayoutWithOutLabel">
        <a-button type="dashed" style="width: 200px" @click="addDomain">
          <a-icon type="plus" /> 添加段落
        </a-button>
      </a-form-model-item> -->

      <a-form-model-item label="配图展示:"> </a-form-model-item>
      <div class="clearfix" v-if="uploadBox">
        <a-upload
          :action="uploadFileUrl"
          list-type="picture-card"
          :file-list="fileList"
          :headers="headers"
          :before-upload="beforeUpload"
          :remove="removefile"
          @preview="handlePreview"
          @change="handleChangeUpload"
        >
          <div v-if="fileList.length < 4">
            <a-icon type="plus" />
            <div>上传图片</div>
          </div>
        </a-upload>
        <a-modal
          :visible="previewVisible"
          :footer="null"
          @cancel="handleCancel"
        >
          <img alt="example" style="width: 100%" :src="previewImage" />
        </a-modal>
      </div>

      <a-form-model-item label="发布形式:">
        <a-radio-group v-model="deverydayData.status" @change="onChangeStatus">
          <a-radio :value="1"> 公开 </a-radio>
          <a-radio :value="0"> 私密 </a-radio>
          <a-radio :value="2"> 仅粉丝 </a-radio>
        </a-radio-group>
      </a-form-model-item>
      <a-form-model-item v-bind="formItemLayoutWithOutLabel">
        <a-button @click="resetForm('dynamicValidateForm')"> 存稿 </a-button>
        <a-button
          type="primary"
          html-type="submit"
          style="margin-left: 10px"
          @click="submitForm('dynamicValidateForm')"
        >
          发布
        </a-button>
      </a-form-model-item>
    </a-form-model>
  </div>
</template>

<script>
export default {
  name: "sendeveryday",
  data() {
    return {
      discussion: "每日发布",

      /**
       * 图片数据
       */
      uploadFileUrl: "",
      previewVisible: false,
      uploadBox: true,
      previewImage: "",
      headers: {
        oopvr: this.$store.state.index.token,
      },
      fileList: [],

      formItemLayoutWithOutLabel: {
        wrapperCol: {
          xs: { span: 24, offset: 0 },
          sm: { span: 20, offset: 4 },
        },
      },

      formItemLayout: {
        labelCol: {
          xs: { span: 24 },
          sm: { span: 4 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 18 },
        },
      },
      dynamicValidateForm: {
        domains: [{ key: "内容", value: "" }],
      },

      deverydayData: {
        status: 1,
      },
    };
  },

  mounted() {
    this.uploadFileUrl = this.$host + "/vr/upload/file/add";
  },
  methods: {
    /**
     * 完成
     */
    submitForm(formName) {
      let uploadList = [];
      if (this.fileList) {
        this.fileList.map((item, index, array) => {
          uploadList.push({id:item.response.data.fileId,url:item.response.data.fileUrl});
        });
      }
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$post("/vr/netuser/dynamic/add", {
            dynamic_conent: this.dynamicValidateForm.domains[0].value,
            status: this.deverydayData.status,
            images: uploadList,
          })
            .then((response) => {
              if (response.code != 1) {
                return this.$message.error(response.data, 5);
              }
              this.$message.success("提交成功！审核阶段。。。");
              this.backBefor();
            })
            .catch((error) => {
              this.$message.error(error.data);
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },

    /**
     * 重置
     */
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    /**
     * 删除
     */
    removeDomain(item) {
      let index = this.dynamicValidateForm.domains.indexOf(item);
      if (index !== -1) {
        this.dynamicValidateForm.domains.splice(index, 1);
      }
    },
    // /**
    //  * 添加
    //  */
    // addDomain() {
    //   if(this.dynamicValidateForm.domains.length>=4){
    //     return this.$message.error("最多四段文字喔！")
    //   }
    //   this.dynamicValidateForm.domains.push({
    //     value: "",
    //     key: "第" + (this.dynamicValidateForm.domains.length + 1) + "段文字",
    //   });
    // },

    /**
     * 图片数据
     */
    handleCancel() {
      this.previewVisible = false;
    },
    async handlePreview(file) {
      if (!file.url && !file.preview) {
        file.preview = await this.getBase64(file.originFileObj);
      }
      this.previewImage = file.url || file.preview;
      this.previewVisible = true;
    },
    removefile(file) {
      console.log(file.response.data.fileEtag);
      this.$post("/vr/upload/file/delete", {
        etag: file.response.data.fileEtag,
      })
        .then((response) => {
          if (response.code != 1) {
            return this.$message.error(response.data, 5);
          }
          this.$message.success("删除" + file.name + "成功！");
        })
        .catch((error) => {
          this.$message.error(error.data);
        });
    },
    beforeUpload(file) {
      return new Promise((resolve, reject) => {
        var testmsg = /^image\/(jpeg|png|jpg)$/.test(file.type);
        const isLt2M = file.size / 1024 / 1024 <= 2; //图片大小不超过5MB
        if (!testmsg) {
          this.$message.error("只能上传 JPG, JPEG, GIF 和 PNG 格式的图片喔!");
          return reject(false);
        }
        if (!isLt2M) {
          this.$message.error("上传图片的大小不能超过 2M!", 3);
          return reject(false);
        }
        return resolve(true);
      });
    },
    handleChangeUpload({ fileList }) {
      this.fileList = fileList;
    },
    getBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = (error) => reject(error);
      });
    },

    /**
     * 发布形式
     */
    onChangeStatus(e) {
      this.deverydayData.status = e.target.value;
    },
  },
};
</script>

<style lang="less" scoped>
.sendeveryday {
  width: 100%;
  // background-color: darkgray;
  padding: 5px 0px;
  .suffix {
    position: relative;
    user-select: none;
    color: rgba(97, 95, 95, 0.781);
    font-size: 16px;
  }
  .clearfix {
    margin-top: -3%;
    margin-left: 18%;
  }
  .dynamic-delete-button {
    cursor: pointer;
    position: relative;
    top: -15px;
    font-size: 24px;
    color: #999;
    transition: all 0.3s;
  }
  .dynamic-delete-button:hover {
    color: #777;
  }
  .dynamic-delete-button[disabled] {
    cursor: not-allowed;
    opacity: 0.5;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/user/usercolumn/release/sendeveryday.vue